<template>
  <div v-if="showAdminBoard" style="display: none;"></div>
  <div class="container">
    <header class="jumbotron">
      <h3>
        <strong>{{currentUser.username}}</strong> DashBoard
      </h3>
    </header>
    <p>
      <strong>Email:</strong>
      {{currentUser.email}}
    </p>
    <p>
      <strong>Saldo:</strong>
      R$ {{ balance.user.toFixed(2) }}
    </p>
    
  </div>
  <div v-if="showAdminBoard" class="container">
    <header class="jumbotron">
      <h3>
        <strong>GG Poker</strong> DashBoard
      </h3>
    </header>
    <p>
      <strong>Saldo RoyalPag:</strong>
      R$ {{ balance.royal.toFixed(2) }}
    </p>
    <p>
      <strong>Saldo com usuários:</strong>
      R$ {{ balance.totaluser.toFixed(2) }}
    </p>
    <p>
      <strong>Saldo disponivel:</strong>
      R$ {{ balance.available.toFixed(2) }}
    </p>
    
  </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
  name: 'Profile',
  data() {
    return {
      balance: {
        user:0,
        royal:0,
        totaluser:0,
        available:0,
      },
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    loggedIn() {
      return (this.$store.state.auth.status.loggedIn && this.$store.state.auth.user.validOTP);
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_ADMIN');
      }
      return false;
    },
  },
  mounted() {
    if (!this.currentUser || !this.loggedIn) {
      console.log("Profile enviando para Login");
      this.$root.logOut();
    }
    if (this.loggedIn) {
      UserService.getBalance().then(
        (response) => {
          console.log(response);
          if (response.data.result) {
            this.balance.user = response.data.user;
            if(this.showAdminBoard){
              this.balance.royal = response.data.royal;
              this.balance.totaluser = response.data.totaluser;
              this.balance.available = response.data.available;
            }
          }
        },
        (error) => {
          console.log(error);
          this.rows = [];
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  }
};
</script>